import SpmLayout from './SpmLayout';

export default SpmLayout;